import type * as Repository from "@/components/features/faq/model/repository";
import type * as ModelType from "@/components/features/faq/model/type";

const contentsConverter = (serverModel: Array<Repository.Query.ArticleData>): Array<ModelType.Content> => {
	return (
		serverModel
			// タイトル/カテゴリ/サブカテゴリ/公開URLがないものは除外
			.filter((data) => data.title && data.category && data.subcategory && data.public_url)
			.map((data) => ({
				id: data.article_id,
				text: data.title,
				url: data.url,
				publicUrl: data.public_url,
				categoryName: data.category,
				subcategoryName: data.subcategory,
			}))
	);
};

export const serverModelToInputModelConverter = (
	hostServerModel: Array<Repository.Query.ArticleData>,
	guestServerModel: Array<Repository.Query.ArticleData>,
): ModelType.QueryData => {
	return {
		host: {
			contents: contentsConverter(hostServerModel),
		},
		guest: {
			contents: contentsConverter(guestServerModel),
		},
	};
};
